import Reward from './Reward'
import { RewardModalProps } from './Reward'

export type { RewardModalProps }

export default Reward
